import React, { FC, useMemo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { TranslationImpl } from 'ia-react-core/~/services/translation/Translation/Translation';
import { LanguageState } from 'ia-react-core/~/interfaces/LanguageState';
import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

import compose from '../../../utils/components/#compose';
import Translation from '../../../services/translation/Translation';
import injectReducer from '../../redux/injectReducer';
import injectSaga from '../../redux/injectSaga';
import languageReducerFactory from './languageReducerFactory';
import saga from './languageSaga';
import TRANSLATION from '../../../constants/TRANSLATION';
import getLanguageCode from '../../../utils/language/getLanguageCode';
import withHtmlLang from './withHtmlLang';

export interface ImplementTranslationProps {}

export interface TranslationImplementation {
  t: (ley: string, options: object) => string;
}

/**
 * @component
 * @visibleName implementTranslation
 */
export default function implementTranslation(implementation: TranslationImpl) {
  Translation.setImplementation(implementation);

  const reducer = languageReducerFactory({ defaultLocale: getLanguageCode(Translation.language) });

  return (WrappedComponent: FC<ImplementTranslationProps>) => {
    const ImplementTranslation = (props: ImplementTranslationProps) => {
      const ComposedWrappedComponent = useMemo<FC<ImplementTranslationProps>>(() => compose<any>(
        injectReducer<ImplementTranslationProps, LanguageState>({ key: TRANSLATION.REDUCER_KEY, reducer }),
        injectSaga<ImplementTranslationProps, LanguageState>({ key: TRANSLATION.REDUCER_KEY, saga }),
        withHtmlLang,
      )(WrappedComponent), []);

      return (
        <ComposedWrappedComponent {...props} />
      );
    };

    ImplementTranslation.displayName = getWrappedDisplayName('ImplementTranslation', WrappedComponent);

    return hoistNonReactStatics(ImplementTranslation, WrappedComponent);
  };
}
